export const QUARTER_SELECTION_FROM = {
    DOWNLOAD_TEMPLATE: "Download_Template",
    GOTONEXTSTEPFROMFILEUPLOADSTEP: "GoToNextStepFromFileUploadStep"
}

export const BATCH_FORMS_LOADING_STATES = {
    SELECT_YEAR_LOADING: "SELECT_YEAR_LOADING",
    SELECT_YEAR_READY: "SELECT_YEAR_READY",
    STEP1_PAGE_LOADING: "STEP1_PAGE_LOADING",
    STEP1_PAGE_READY: "STEP1_PAGE_READY",
    UPLOAD_FILE_PAGE_LOADING: "UPLOAD_FILE_PAGE_LOADING",
    UPLOAD_FILE_PAGE_READY: "UPLOAD_FILE_PAGE_READY",
    PASTE_FILE_PAGE_LOADING: "PASTE_FILE_PAGE_LOADING",
    PASTE_FILE_PAGE_READY: "PASTE_FILE_PAGE_READY",
    MATCHING_PAGE_LOADING: "MATCHING_PAGE_LOADING",
    MATCHING_PAGE_READY: "MATCHING_PAGE_READY",
    GRID_PAGE_LOADING: "GRID_PAGE_LOADING",
    GRID_PAGE_READY: "GRID_PAGE_READY",
    GRID_PAGE_TABLE_LOADING: "GRID_PAGE_TABLE_LOADING",
    GRID_PAGE_TABLE_READY: "GRID_PAGE_TABLE_READY",
    GRID_PAGE_SELECTED_PAYERS_LOADING: "GRID_PAGE_SELECTED_PAYERS_LOADING",
    GRID_PAGE_SELECTED_PAYERS_READY: "GRID_PAGE_SELECTED_PAYERS_READY",
    GRID_PAGE_DOWNLOAD_ACTION_LOADING: "GRID_PAGE_DOWNLOAD_ACTION_LOADING",
    GRID_PAGE_DOWNLOAD_ACTION_READY: "GRID_PAGE_DOWNLOAD_ACTION_READY",
    GRID_PAGE_EDIT_BOX_ACTION_LOADING: "GRID_PAGE_EDIT_BOX_ACTION_LOADING",
    GRID_PAGE_EDIT_BOX_ACTION_READY: "GRID_PAGE_EDIT_BOX_ACTION_READY",
    SUBMIT_EDITED_PAYER_LOADING: "SUBMIT_EDITED_PAYER_LOADING",
    SUBMIT_EDITED_PAYER_READY: "SUBMIT_EDITED_PAYER_READY",
    SUBMIT_EDITED_RECIPIENT_LOADING: "SUBMIT_EDITED_RECIPIENT_LOADING",
    SUBMIT_EDITED_RECIPIENT_READY: "SUBMIT_EDITED_RECIPIENT_READY",
    GET_FORM_SETTINGS_LOADING: "GET_FORM_SETTINGS_LOADING",
    GET_FORM_SETTINGS_READY: "GET_FORM_SETTINGS_READY",
}

export const BATCH_FORM_STATES_MESSAGE_MAP = {
    [BATCH_FORMS_LOADING_STATES.SELECT_YEAR_LOADING]: "",
    [BATCH_FORMS_LOADING_STATES.STEP1_PAGE_LOADING]: "",
    [BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_LOADING]: "",
    [BATCH_FORMS_LOADING_STATES.PASTE_FILE_PAGE_LOADING]: "",
    [BATCH_FORMS_LOADING_STATES.MATCHING_PAGE_READY]: "",
    [BATCH_FORMS_LOADING_STATES.GRID_PAGE_LOADING]: "",
    [BATCH_FORMS_LOADING_STATES.GRID_PAGE_TABLE_LOADING]: "",
    [BATCH_FORMS_LOADING_STATES.GRID_PAGE_SELECTED_PAYERS_LOADING]: "",
    [BATCH_FORMS_LOADING_STATES.GRID_PAGE_DOWNLOAD_ACTION_LOADING]: "",
    [BATCH_FORMS_LOADING_STATES.GRID_PAGE_EDIT_BOX_ACTION_LOADING]: "",
    [BATCH_FORMS_LOADING_STATES.SUBMIT_EDITED_PAYER_LOADING]: "Updating Payer...",
    [BATCH_FORMS_LOADING_STATES.SUBMIT_EDITED_RECIPIENT_LOADING]: "Updating Recipient...",
}